<template>
  <el-row>
    <el-col :span="24" style="position: relative">
      <div style="display: flex; justify-content: center; align-items: center; width: 37rem; line-height: 5.5rem; font-size: 4rem; font-weight: 700; color: #fff">
        专业，规范，高效的 工程建筑数据服务商
      </div>
      <div style="display: flex; justify-content: center; align-items: center; flex-flow: column; width: 1108px; color: #fff; position: absolute; bottom: 5rem; font-size: 1.15rem">
        <div style="opacity: 0.66; text-align: center; line-height: 2rem">
          从工程建设过程的实际业务出发，依托自身在BIM领域积累的技术实力 <br>
          为工程建筑行业提供可落地性的信息化解决方案，为新工程助力，为客户创造长期价值
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div style="margin: 4rem 0 2rem; display: flex; justify-content: center; align-items: center">
        <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(90deg,rgba(255,255,255,0), #bababa)"></span>
        <span style="margin: 0 2rem; font-size: 1rem; font-weight: 700; color: #888888">合作客户</span>
        <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(to left, rgba(255,255,255,0), #bababa)"></span>
      </div>
      <div style="display: flex; justify-content: center">
        <div style="display: flex; justify-content: flex-start; width: 1108px; flex-wrap: wrap; margin-bottom: 2rem">
          <el-image src="../../../static/images/Desktop/Desktop_001.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem 1rem 0"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_002.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_003.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_004.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_005.png" style="width: 10rem; height: 10rem; margin: 1rem 0 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_006.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem 1rem 0"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_007.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_008.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_009.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_010.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_011.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem 1rem 0"></el-image>
          <el-image src="../../../static/images/Desktop/Desktop_013.png" style="width: 10rem; height: 10rem; margin: 1rem 2rem"></el-image>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
    export default {
        name: "Desktop",
        data: function () {
          return {
          }
        },
        components: {

        },
        created() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>
  .el-main > .el-row {
    min-width: 1108px;
  }

  .el-main > .el-row > div:first-child {
    height: 100vh;
    background: url('../../../static/images/Desktop/Desktop_bg.png') no-repeat center;
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    background-color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Desktop.vue